export default "__VITE_ASSET__B4XGqSC0__"